const urlsByAttachmentId = new Map<string, string>();

export const getChatAttachmentUrl = (attachmentId: string): string | undefined => urlsByAttachmentId.get(attachmentId);

export const resolveImageAttachmentUrls = async (
  chatSession: connect.AgentChatSession,
  attachments: connect.AttachmentItem[] | undefined
): Promise<boolean> => {
  const approvedImages = (attachments ?? []).filter(
    ({ ContentType, Status }) => Status === 'APPROVED' && ContentType.startsWith('image/')
  );

  const fetched = await Promise.all(
    approvedImages.map(async ({ AttachmentId }) => {
      try {
        urlsByAttachmentId.set(AttachmentId, await chatSession.getAttachmentURL({ attachmentId: AttachmentId }));
        return true;
      } catch (error) {
        console.error(`Failed to fetch attachment URL for ${AttachmentId}:`, error);
        return false;
      }
    })
  );

  return fetched.some(Boolean);
};
